<template>
  <v-container class="container">
    <v-layout>
      <v-flex xs5>
        <v-select
          v-model="poiSubCategory.poiSubCategoryId"
          :items="poiSubCategoryList"
          no-data-text="このカテゴリーは絞り込み機能の対象外です。"
          item-text="name"
          item-value="id"
          placeholder="条件を指定してください"
        />
      </v-flex>
      <v-flex xs1 ml-4>
        <v-btn @click="onClickDelete" small fab>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <div v-if="isShowSelector">
      <v-btn v-if="loading" loading flat style="width: 100%;" />
      <v-layout v-else-if="isNumericalCondition" wrap>
        <v-flex xs2>
          <v-text-field
            @keydown.arrow-down.prevent
            @keydown.arrow-up.prevent
            @wheel.prevent
            v-model.number="poiSubCategory.value"
            type="number"
            class="text-field"
          />
        </v-flex>
        <v-flex xs2 ml-5>
          <v-select
            v-model="poiSubCategory.condition"
            :items="conditions"
            item-text="name"
            item-value="value"
          />
        </v-flex>
      </v-layout>
      <AppTwoColumnsSelector
        v-else
        @changeChosenItems="addSubCateoryValue($event)"
        :items="poiSubCategoryValues"
        :available-label="selectedSubcategoryName + '一覧'"
        :chosen-label="'対象' + selectedSubcategoryName"
        class="selector"
        item-value="value"
        item-text="valueLabel"
      />
    </div>
  </v-container>
</template>

<script>
import { POICategoryRepository } from '@/models/POICategoryRepository'
import { ConditionType } from '@/models/POI/Constants'

export default {
  name: 'SubcategoryItem',
  props: {
    index: {
      type: Number,
      default: 0,
    },
    poiSubCategory: {
      type: Object,
      default: () => {},
    },
    selectedPoiCategoryId: {
      type: [Number, null],
      default: 0,
    },
    poiSubCategoryList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      poiSubCategoryValues: [],
      isNumericalCondition: true,
      loading: false,
    }
  },
  computed: {
    isShowSelector() {
      return this.poiSubCategory.poiSubCategoryId !== null
    },
    conditions() {
      return [
        { name: '以上', value: 'greater' },
        { name: '以下', value: 'less' },
      ]
    },
    selectedSubcategoryName() {
      if (this.selectedPoiCategoryId === null || this.isNumericalCondition) {
        return ''
      }
      const selectedPoiCategoryObject = this.poiSubCategoryList.find(
        poiSubCategory =>
          poiSubCategory.id === this.poiSubCategory.poiSubCategoryId,
      )
      return selectedPoiCategoryObject.name
    },
  },
  watch: {
    async 'poiSubCategory.poiSubCategoryId'(newVal) {
      if (newVal === null) return
      this.loading = true
      this.poiSubCategoryValues = await POICategoryRepository.getSubcategoryValues(
        this.selectedPoiCategoryId,
        newVal,
      )
      const targetSubCategory = this.poiSubCategoryList.find(
        subCategory => subCategory.id === newVal,
      )

      this.isNumericalCondition =
        targetSubCategory.type === ConditionType.number
      this.poiSubCategory.type = this.isNumericalCondition
        ? ConditionType.number
        : ConditionType.select

      this.loading = false
    },
  },
  methods: {
    onClickDelete() {
      this.$emit('deleteCondition', this.index)
    },
    addSubCateoryValue(ids) {
      this.poiSubCategory.addSubCateoryValue(ids, this.poiSubCategoryValues)
    },
  },
}
</script>

<style scoped>
.selector {
  width: 200px;
}
.text-field {
  width: 100px;
}
.container {
  padding-top: 0;
}
</style>
